export default {
  SEARCH_NOT_INITIATED: 'SEARCH_NOT_INITIATED',
  SEARCH_IN_PROGRESS: 'SEARCH_IN_PROGRESS',
  SEARCH_DONE: 'SEARCH_DONE',
};